/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
    'star': {
        width: 60,
        height: 60,
        viewBox: '0 0 20 18',
        data: '<path pid="0" d="M9.08508 1.07381C9.43588 0.278663 10.5641 0.278664 10.9149 1.07381L12.7846 5.31171C12.9298 5.6408 13.2405 5.86656 13.5983 5.90294L18.2066 6.37152C19.0712 6.45943 19.4199 7.53245 18.772 8.11179L15.3193 11.1995C15.0512 11.4393 14.9325 11.8046 15.0085 12.1562L15.9869 16.6837C16.1704 17.5331 15.2577 18.1963 14.5065 17.7592L10.5029 15.4296C10.192 15.2487 9.80796 15.2487 9.49707 15.4296L5.4935 17.7592C4.74232 18.1963 3.82956 17.5331 4.01313 16.6837L4.99152 12.1562C5.06749 11.8046 4.9488 11.4393 4.68069 11.1995L1.22796 8.11179C0.580137 7.53245 0.928782 6.45943 1.79341 6.37152L6.40166 5.90294C6.7595 5.86656 7.07023 5.6408 7.21542 5.31171L9.08508 1.07381Z" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/>'
    }
})
